if (window.$zopim) {
    window.$zopim(function() {
        window.$zopim.livechat.hideAll();
    });
}
